module.exports = __webpack_public_path__ + "img/exit_18.928a9b86.svg";